/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Draft_Gallery_Photos_HintInputs */

const cs_draft_gallery_photos_hint = /** @type {(inputs: Draft_Gallery_Photos_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Použije ${i?.count} fotek ze záložky Fotky a média (první = cover). Pořadí měňte tam — ne zde.`)
};

const en_draft_gallery_photos_hint = /** @type {(inputs: Draft_Gallery_Photos_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uses ${i?.count} photos from Photos & Media (first = cover). Reorder there — not here.`)
};

/**
* | output |
* | --- |
* | "Uses {count} photos from Photos & Media (first = cover). Reorder there — not here." |
*
* @param {Draft_Gallery_Photos_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_gallery_photos_hint = /** @type {((inputs: Draft_Gallery_Photos_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Gallery_Photos_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_gallery_photos_hint(inputs)
	return cs_draft_gallery_photos_hint(inputs)
});